import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TReportsApi } from './types';

export const reports: TReportsApi = {
	getAvailableReportTypes: () =>
		http.get(endpoint.reports.GET_AVAILABLE_REPORT_TYPES).then((response) => response.data),
	getSalesReports: (payload) =>
		http
			.post(endpoint.reports.GET_SALES_REPORTS(payload.reportsType), {
				pageNumber: payload.pageNumber,
				pageSize: payload.pageSize,
			})
			.then((response) => response.data),
	downloadSalesReport: (payload) =>
		http
			.get(endpoint.reports.DOWNLOAD_SALES_REPORTS(payload.reportId, payload.format), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	getVatReports: (payload) =>
		http
			.post(endpoint.reports.GET_VAT_REPORTS(payload.reportType), {
				pageNumber: payload.pageNumber,
				pageSize: payload.pageSize,
			})
			.then((response) => response.data),
	downloadVatReport: (payload) =>
		http
			.get(
				endpoint.reports.DOWNLOAD_VAT_REPORT(payload.reportType, payload.reportId, payload.format),
				{
					responseType: 'blob',
				},
			)
			.then((response) => response.data),
};
